import React from 'react';
import styles from './Button.module.css';

export default function Button({
  variant = 'primary',
  className = '',
  children,
  type = 'button',
  ...rest
}) {
  const variantClass = styles[variant] || styles.primary;

  const classNames = [styles.btn, variantClass, className]
    .filter(Boolean)
    .join(' ');

  return (
    <button type={type} className={classNames} {...rest}>
      {children}
    </button>
  );
}
